import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Badge, Button, Flex, Paragraph, Spinner, Text } from "theme-ui";
import { bucketUrl } from "../../../utils/global";
import Confetti from "react-confetti";
import { getUnlockedBadges } from "../../../store/actions/Rating.Action";
import { ActionUpdateById } from "../../../store/actions/CommonAction";

interface Gradients {
    // default: string;
    GOLD: string;
    BRONZE: string;
    SILVER: string;
    PLATINUM: string;
}
const progressGradients: Gradients = {
    // default: "linear-gradient(141.14deg, #B6947E 14.91%, #F8DAC8 93.31%)",
    GOLD: "linear-gradient(135.34deg, #8C421D 15.43%, #FBE67B 43.8%, #F7DF77 56.37%, rgba(244, 235, 69, 0.47) 62.18%, #F7D14E 69.97%, #D4A041 86.26%)",
    BRONZE: "linear-gradient(141.14deg, #B6947E 14.91%, #8F6959 30.59%, #FECFB3 52.15%, #AC836E 67.44%, #B6947E 79.98%, #F8DCCB 93.31%)",
    SILVER: "linear-gradient(137.95deg, #7A96AC 2.28%, #EAEFF3 14.6%, #C2D4E1 25.6%, #D2D2D2 35.6%, #D4DEE5 52.41%, #ABBDC8 70.17%, #BCCAD7 95.24%)",
    PLATINUM: " linear-gradient(222.43deg, #FDFFFE -4.31%, #7ABBAC 19.22%, #B1FFEF 35.59%, #8AD2C3 50.43%, #CFFEF4 71.92%, #6CA196 89.31%, #35544E 98.01%)"
};
const getBadgeBackground = (badge: any): string => {

    if (!badge?.badgeId?.name) return '';
    // Convert the badge name to lowercase and cast it as a key of Gradients.
    const badgeName = badge.badgeId.name as keyof Gradients;
    return progressGradients[badgeName] || '';
};

const BadgeModalComponent = ({ badges, isOpen, onClose }: any) => {
    // if (!badges?.badgeId) return null;

    const dispatch = useDispatch()
    const background = getBadgeBackground(badges)
    const badgeId = badges?._id;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showConfetti, setShowConfetti] = useState<boolean>(false);

    const handleClick = () => {
        setIsLoading(true);

        const payload = {
            isAcknowledge: true
        }

        dispatch(ActionUpdateById({ Query: `gamification/edit-gamification-field/${badgeId}`, obj: payload }, (res: any) => {
            if (res.status) {
                setIsLoading(false);
                onClose();
            }
            else {
                setIsLoading(false);
                onClose();
                alert('Failed to acknowledge the badge');
            }
        }))
    }
    useEffect(() => {
        if (isOpen) {
            setShowConfetti(true);
            setTimeout(() => setShowConfetti(false), 5000);
        }
    }, [isOpen]);

    return (
        <>
            {showConfetti && <Confetti width={window.innerWidth} height={window.innerHeight} />}

            <Modal isOpen={isOpen} toggle={onClose} centered modalClassName={'overflow-y-auto'} backdrop="static">
                {/* <ModalHeader toggle={onClose} sx={{ fontWeight: 'bold' }}>
                {''}
            </ModalHeader> */}
                <ModalBody className="text-center" style={{
                    background: "linear-gradient(316deg, #4A1E94 0%, #9E50CC 74%)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}>
                    {/* <Card sx={{ border: 'none' }}> */}
                    <div >
                        <Text sx={{
                            fontSize: '50px',
                            fontWeight: 700,
                            fontFamily: 'Parisienne',
                            background: "linear-gradient(135deg, #FFD700, #FFB800, #FFA500)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            // display: "inline-block",
                        }} >{'Congratulations! '}</Text>
                        {badges?.badgeId?.name === "PLATINUM" && (
                            <Paragraph sx={{ fontSize: "20px", fontWeight: 500, color: "#8DF7FF", textShadow: "0px 0px 8px rgba(141, 247, 255, 0.7)" }}>
                                {'You have unlocked a secret badge!'}
                            </Paragraph>
                        )}                    <div style={{
                            position: "relative", display: "inline-block",
                        }}>
                            <img
                                src={bucketUrl + badges?.badgeId?.icon.split(".com/")[1]}
                                alt="badge"
                                style={{
                                    width: "70%",
                                    borderRadius: "8px",
                                    position: "relative",
                                    animation: "rotateShine 5s linear infinite",
                                    // boxShadow: "0px 0px 15px rgba(255, 215, 0, 0.6)",
                                }}
                            />
                        </div>
                        <Flex sx={{ alignItems: "center", justifyContent: 'center', gap: 4 }}>
                            <Badge
                                sx={{
                                    background: background || "#60B680",
                                    color: "white",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    px: '12px',
                                    py: '6px',
                                    borderRadius: "12px",
                                    // display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}
                            >
                                {<img src={bucketUrl + badges?.
                                    badgeCriteria
                                    ?.icon.split(".com/")[1]} style={{ width: '25px', height: '25px', marginRight: 5 }} />}

                                {badges?.badgeCriteria?.name}
                            </Badge>
                        </Flex>
                        {/* </Card> */}
                    </div>
                </ModalBody>
                <ModalFooter style={{
                    background: "linear-gradient(316deg, #3e187a 0%, #994ecc 74%)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }} className="justify-content-center">
                    <Button
                        sx={{
                            color: 'white', px: 6, fontWeight: 700,
                            background: "linear-gradient(135deg, #B22222, #D32F2F, #FF5733)",
                            transition: "0.3s",
                            "&:hover": {
                                background: "#f00",
                            },
                        }}
                        onClick={handleClick}
                        disabled={isLoading}
                    >
                        {isLoading ? (<Spinner sx={{ color: 'white', width: 5, p: 0, m: 0 }} />) : ("CONTINUE")}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

const BadgeModal = () => {
    const dispatch = useDispatch();
    const { unlockedBadges, loader } = useSelector((state: any) => state.rating);
    const [currentModalIndex, setCurrentModalIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(true);

    // Optionally, dispatch an action to fetch badges on mount
    useEffect(() => {
        dispatch(getUnlockedBadges());
    }, []);

    const validBadges = unlockedBadges?.data?.filter((badge: any) => badge?.badgeId !== null) || [];

    useEffect(() => {
        if (validBadges.length > 0) {
            setCurrentModalIndex(0);
            setIsOpen(true);
        }
    }, [unlockedBadges]);

    const handleCloseModal = () => {
        setIsOpen(false);
        if (currentModalIndex < validBadges?.length - 1) {
            setTimeout(() => {
                setCurrentModalIndex(prevIndex => prevIndex + 1);
                setIsOpen(true);
            }, 300);
        } else {
            setCurrentModalIndex(-1);
        }
    };
    if (currentModalIndex === -1 || validBadges?.length === 0) return null;

    return (
        <BadgeModalComponent
            badges={validBadges[currentModalIndex]}
            isOpen={isOpen}
            onClose={handleCloseModal}
        />
    );
};

export default BadgeModal;